import React from 'react';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import { noop } from 'lodash';

const GUEST_SETTINGS =[
    {
        refValue: 8,
        code: 'showRoomRequests',
        title: 'Show Hotel and Profile Room Preferences Selections'
    },
    {
        refValue: 9,
        code: 'displayCommentArea',
        title: 'Show Special Requests Comments Field'
    },
    {
        refValue: 10,
        code: 'showAdditionalGuests',
        title: 'Show Additional Guests'
    },
    {
        refValue: 11,
        code: 'enableAdditionalGuestEmailAddresses',
        title: 'Show Additional Guest Email'
    },
    {
        refValue: 1,
        code: 'additionalGuestCountInclude',
        title: 'Include Number of Children in Additional Guest Count'
    },
    {
        refValue: 12,
        code: 'enableGuestDataCollectionConsent',
        title: 'Enable Checkout form email/phone data capture consent'
    }
];

const GuestSettings = ({
   currentConfigCopy = {},
   isDisabled = false,
   registerSection,
   sectionStyleHandler,
   toggleConfigBoolean = noop
}) => {
    return (
        <section
            className="row spark-panel__content"
            ref={registerSection(3)}
            style={sectionStyleHandler(3)}
        >
            <div className="col-xs-12">
                <h4>Guest Settings</h4>
                <p>Determine whether guests can enter room requests and comments</p>
                {GUEST_SETTINGS.map((setting, index) => (
                    <ConfigurationCheckbox
                        key={`guest-setting-${index}`}
                        title={setting.title}
                        ref={registerSection(setting.refValue)}
                        style={sectionStyleHandler(setting.refValue)}
                        isDisabled={isDisabled}
                        code={setting.code}
                        onChange={toggleConfigBoolean}
                        value={currentConfigCopy[setting.code]}
                    />
                ))}
            </div>
        </section>
    );
};

export default GuestSettings;


// WEBPACK FOOTER //
// ./src/components/pages/pages/guestPayment/guest-settings.js